export default __webpack_public_path__ + "static/section_9_item_2-41b8cb7f782d437b618a6d94c025091d.png";